import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { AdminService, LBSubscription } from './admin.service';
@Injectable()
export class ResolverSubscriptionsService implements Resolve<LBSubscription[]> {

	constructor(
		private adminService: AdminService
	) { }

	async resolve(): Promise<LBSubscription[]> {
		let subs: LBSubscription[];
		if (!this.adminService.subscriptions.getValue()) {
			subs = await this.adminService.getSubscriptions();
		} else {
			subs = this.adminService.subscriptions.getValue();
		}
		return subs;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-subscriptions.service.ts